<template>
  <div class="collage-carousel">
    
    <div class="collage-grid">
      <div
        v-for="(image, index) in images"
        :key="index"
        :ref="el => setCollageItem(el, index)"
        class="collage-item"
        :class="{ visible: imageVisible[index] }"
        @click="enlargeImage(index)"
      >
        <img
          :src="image"
          class="collage-image"
          :alt="'Imagen ' + index"
        >
      </div>
    </div>

    <!-- Modal -->
    <div
      v-if="isImageEnlarged"
      class="image-modal"
      @click="closeModal"
    >
      <img
        :src="images[currentIndex]"
        class="enlarged-image"
      >
    </div>
  </div>
 
</template>

<script>
import { ref, onMounted, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'CollageAnimado',
  setup() {
    const images = [
      require('@/assets/i2.jpeg'),
            require('@/assets/imagen_1.webp'),

         require('@/assets/image5.jpeg'),

   require('@/assets/image0.jpeg'),

            require('@/assets/image1.jpeg'),
                        require('@/assets/image2.jpeg')

                        ,
                                    require('@/assets/image3.jpeg')
,
            require('@/assets/image4.jpeg')

            
    ]

    const currentIndex = ref(0)
    const isImageEnlarged = ref(false)
    const collageItems = ref([])
    const imageVisible = ref(new Array(images.length).fill(false))

    const setCollageItem = (el, index) => {
      collageItems.value[index] = el
    }

    const enlargeImage = (index) => {
      currentIndex.value = index
      isImageEnlarged.value = true
    }

    const closeModal = () => {
      isImageEnlarged.value = false
    }

    const observeImages = () => {
      const options = { threshold: 0.3 }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const index = collageItems.value.indexOf(entry.target)
          if (entry.isIntersecting) {
            imageVisible.value[index] = true
            animateIn(entry.target, index)
            observer.unobserve(entry.target)
          }
        })
      }, options)

      collageItems.value.forEach((el) => el && observer.observe(el))
    }

    const animateIn = (el, index) => {
      const direction = index % 2 === 0 ? -100 : 100
      gsap.fromTo(el,
        { x: direction, opacity: 0, scale: 0.9 },
        {
          x: 0,
          opacity: 1,
          scale: 1,
          duration: 1.2,
          delay: index * 0.1,
          ease: 'power3.out'
        }
      )
    }

    onMounted(async () => {
      await nextTick()
      observeImages()
    })

    return {
      images,
      currentIndex,
      isImageEnlarged,
      enlargeImage,
      closeModal,
      collageItems,
      imageVisible,
      setCollageItem
    }
  }
}
</script>

<style scoped>
.collage-carousel {
  width: 100%;
  max-width: 100%;
  padding: 40px 0;
  background-color: rgb(224,152,162);
  margin: 0;
  display: flex;
  justify-content: center;
}

.collage-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
  width: 90%;
  max-width: 1200px;
}

.collage-item {
  border: none;
  border-radius: 16px;
  overflow: hidden;
  background-color: #fff;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.25);
  transform-origin: center;
  opacity: 0;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.collage-item.visible {
  opacity: 1;
}

.collage-image {
  width: 100%;
  height: auto;
  object-fit: cover;
  display: block;
  transition: transform 0.3s ease;
}

.collage-image:hover {
  transform: scale(1.05);
}

.image-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(10, 10, 10, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.enlarged-image {
  max-width: 90%;
  max-height: 90%;
  border-radius: 12px;
  object-fit: contain;
}
</style>